module.exports = __webpack_public_path__ + "img/s-powered-by-Google-Maps.83b2beca.png";